module.exports = __webpack_public_path__ + "img/ro-rise-smarthome-img-mobile.dfb58ba4.jpg";